__turbopack_context__.v({
  "aws": "CloudPlatforms-module__dt9G8G__aws",
  "azure": "CloudPlatforms-module__dt9G8G__azure",
  "bar": "CloudPlatforms-module__dt9G8G__bar",
  "btn": "CloudPlatforms-module__dt9G8G__btn",
  "btnSm": "CloudPlatforms-module__dt9G8G__btnSm",
  "btnXs": "CloudPlatforms-module__dt9G8G__btnXs",
  "ctitle": "CloudPlatforms-module__dt9G8G__ctitle",
  "desc": "CloudPlatforms-module__dt9G8G__desc",
  "eyebrow": "CloudPlatforms-module__dt9G8G__eyebrow",
  "gcp": "CloudPlatforms-module__dt9G8G__gcp",
  "head": "CloudPlatforms-module__dt9G8G__head",
  "section": "CloudPlatforms-module__dt9G8G__section",
  "stackCenter": "CloudPlatforms-module__dt9G8G__stackCenter",
  "subtitle": "CloudPlatforms-module__dt9G8G__subtitle",
  "title": "CloudPlatforms-module__dt9G8G__title",
  "titleRow": "CloudPlatforms-module__dt9G8G__titleRow",
  "wideCard": "CloudPlatforms-module__dt9G8G__wideCard",
  "wideImg": "CloudPlatforms-module__dt9G8G__wideImg",
  "wideImgCol": "CloudPlatforms-module__dt9G8G__wideImgCol",
  "wideInner": "CloudPlatforms-module__dt9G8G__wideInner",
  "wideTextCol": "CloudPlatforms-module__dt9G8G__wideTextCol",
});
